import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import {
  SuspenseWithSentryErrorBoundary,
  withDialogSuspenseErrorBoundary,
} from '@retail/components';
import { ContainedButton, Dialog, TextButton } from '@shared/components';
import { ConditionLevelSelectContainer } from './ConditionLevelSelectContainer';

interface Props {
  open: boolean;
  title: string;
  supplierNumber?: number;
  includePackages?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  headerContent?: React.ReactNode;
  dialogContent: React.ReactNode;
  excistingConditionLevelIds?: string[];
  onSubmit: () => void;
  onClose: () => void;
}

function CreateConditionDialog({
  open,
  title,
  supplierNumber,
  includePackages,
  isDisabled,
  isLoading,
  headerContent,
  dialogContent,
  excistingConditionLevelIds,
  onSubmit,
  onClose,
}: Props) {
  const t = useCalculusTFunction();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{ '& .MuiPaper-root': { minHeight: 400 } }}
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        {headerContent}
        <SuspenseWithSentryErrorBoundary>
          <ConditionLevelSelectContainer
            supplierNumber={supplierNumber}
            includePackages={includePackages}
            excistingConditionLevelIds={excistingConditionLevelIds}
          >
            {() => dialogContent}
          </ConditionLevelSelectContainer>
        </SuspenseWithSentryErrorBoundary>
      </DialogContent>

      <DialogActions>
        <TextButton onClick={onClose}>{t('calculus.cancel')}</TextButton>
        <ContainedButton
          size="small"
          color="secondary"
          disabled={isDisabled}
          loading={isLoading}
          onClick={onSubmit}
        >
          {t('calculus.toApproval')}
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
}

export default withDialogSuspenseErrorBoundary(CreateConditionDialog);
